import { FunctionComponent } from 'preact';
import { LineItem } from '@pperform/pp-data-mappers';
import { Stack } from 'components/Stack';
import { lineItemTestID } from 'components/MerchantTrackingWidget/constants';
import { DetailedWrapper } from './CardFront.styles';
import {
  DescriptionValue,
  DescriptionRow,
  useFormatItemsCard,
} from '../../ItemCommons';
import {
  DetailsWrapper,
  Thumbnail,
  TruncatedTitle,
} from '../../ItemCommons/CommonItem.styles';

interface CardFrontProps {
  card: LineItem;
  ariaHidden?: boolean;
}

const CardFront: FunctionComponent<CardFrontProps> = ({ card, ariaHidden }) => {
  const {
    productName,
    productImageUrl,
    productPrice,
    productQuantity,
    additionalInformation,
    productID,
  } = useFormatItemsCard(card);

  return (
    <DetailsWrapper isTwoColumns aria-hidden={ariaHidden}>
      <Thumbnail
        isRounded={false}
        width={240}
        height="inherit"
        src={productImageUrl}
        alt={productName}
      />
      <DetailedWrapper>
        <Stack direction="column" justify="center">
          <DescriptionRow data-testid={`${lineItemTestID}-name`}>
            <TruncatedTitle isShowFull={false}>{productName}</TruncatedTitle>
          </DescriptionRow>
          {productPrice && (
            <DescriptionRow gap={4} data-testid={`${lineItemTestID}-price`}>
              <DescriptionValue>{`${productPrice.label}: ${productPrice.value}`}</DescriptionValue>
            </DescriptionRow>
          )}

          {productQuantity && (
            <DescriptionRow gap={4} data-testid={`${lineItemTestID}-quantity`}>
              <DescriptionValue>{productQuantity.value}</DescriptionValue>
            </DescriptionRow>
          )}
          {productID && (
            <DescriptionRow
              bottomMargin={12}
              data-testid={`${lineItemTestID}-id`}
            >
              <DescriptionValue>{`${productID.label}: ${productID.value}`}</DescriptionValue>
            </DescriptionRow>
          )}
          {additionalInformation && (
            <DescriptionRow
              gap={4}
              data-testid={`${lineItemTestID}-additional-information`}
            >
              <DescriptionValue>{additionalInformation}</DescriptionValue>
            </DescriptionRow>
          )}
        </Stack>
      </DetailedWrapper>
    </DetailsWrapper>
  );
};

export { CardFront };
